import { create } from 'zustand';
import { ProductOption } from '../apis/models/products/res/ProductOption';
import { uniqBy } from 'lodash';

interface ProductOptionStore {
  productOptions: ProductOption[];
  clear: () => void;
  append: (productOptions: ProductOption[]) => void;
  remove: (productOptionId: number) => void;
  removeMany: (productOptionIds: number[]) => void;
  replaceProductOptions: (productOptions: ProductOption[]) => void;
}

const initialData = {
  productOptions: [],
};

const useProductOptionsStore = create<ProductOptionStore>((set) => {
  return {
    ...initialData,
    clear: () => {
      set((state) => {
        return {
          ...state,
          productOptions: [],
        };
      });
    },
    append: (productOptions: ProductOption[]) => {
      set((state) => {
        let updatedOptions = [...state.productOptions, ...productOptions];
        updatedOptions = uniqBy(updatedOptions, 'id');
        return {
          ...state,
          productOptions: updatedOptions,
        };
      });
    },
    replaceProductOptions: (productOptions: ProductOption[]) => {
      set((state) => {
        return {
          ...state,
          productOptions,
        };
      });
    },
    removeMany: (productOptionIds: number[]) => {
      set((state) => {
        return {
          ...state,
          productOptions: state.productOptions.filter(({ id }) => {
            return !productOptionIds.includes(id);
          }),
        };
      });
    },
    remove: (productOptionId: number) => {
      set((state) => {
        return {
          ...state,
          productOptions: state.productOptions.filter(({ id }) => {
            return id !== productOptionId;
          }),
        };
      });
    },
  };
});

export default useProductOptionsStore;
